import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const nearIntents = {
  displayName: 'NEAR Intents',
  runtime: 'nearIntents',
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 21,

  decoration: {
    color: '#FB4D01',
    contrastColor: getContrastColor('#FB4D01'),
  },
  features: {
    wallet: {
      supported: true,
      import: true,
    },
    vault: {
      supported: false,
      ccqRecovery: false,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'near-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://nearblocks.io',
        token: 'https://nearblocks.io/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge(),
  services: defaultServices(),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'nearIntents', true>;
